import { ModuleWithProviders, NgModule, Optional, Provider, SkipSelf } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormulareModule } from 'app/api/formulare.module';

import { throwIfAlreadyLoaded } from './module-import-guard';
import { ErrorHandlerModule } from './error-handler';

const PROVIDERS: Provider[] = [];

@NgModule({
  declarations: [],
  imports: [CommonModule, FormulareModule, ErrorHandlerModule],
})
export class CoreModule {
  public constructor(@Optional() @SkipSelf() parentModule: CoreModule) {
    throwIfAlreadyLoaded(parentModule, 'CoreModule');
  }

  public static forRoot(): ModuleWithProviders<CoreModule> {
    return {
      ngModule: CoreModule,
      providers: [...PROVIDERS],
    };
  }
}
